import React, { useContext } from 'react';
import { RootContext } from '../../Context/RootContext';
const NodeTitle = ({ node }) => {
    const rootContext = useContext(RootContext);
    if (!!parseInt(rootContext.pluginContext.showContentTitle) && (node === null || node === void 0 ? void 0 : node.title)) {
        if (rootContext.pageContext.noTitle) {
            return React.createElement("h1", { className: "zds-headline-xxl zds-margin-bottom-4" }, node.title);
        }
        else {
            return React.createElement("h2", { className: "zds-headline-xl zds-margin-bottom-4" }, node.title);
        }
    }
    return null;
};
export default NodeTitle;
